import { Box, LinearProgress, useTheme } from '@mui/material';

const LinearLoader = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1301,
        width: '100%',
        '& > * + *': {
          marginTop: theme.spacing(2)
        }
      }}>
      <LinearProgress color="primary" />
    </Box>
  );
};

export default LinearLoader;
